import {style} from '@vanilla-extract/css'

export const staticMapContainer = style({
  cursor: 'pointer',
})
export const staticMapImage = style({
  width: '100%',
  height: 'auto',
  display: 'block',
  verticalAlign: 'top',
})
